export default __webpack_public_path__ + "c64d1ce.png";